import { Typography } from 'antd';
import styled from '@emotion/styled';
export const Paragraph = styled(Typography.Paragraph)`
  white-space: pre-line;
`;
